import { useEffect, useState } from "react";
import { getRandomViewCount } from "../../../../../helpers/getRandomViewCount";
import styles from "./PhoneLayers.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

export const ViewCount = () => {
  const [viewCount, setViewCount] = useState(getRandomViewCount());

  useEffect(() => {
    const interval = setInterval(() => {
      setViewCount((prevCount) => {
        if (prevCount < 999) {
          return prevCount + 1;
        } else {
          clearInterval(interval);
          return prevCount;
        }
      });
    }, 2000);

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <p className={styles.viewCount}>
      <FontAwesomeIcon icon={faEye} />
      {viewCount}k live views
    </p>
  );
};
